<template>
  <div>
    <v-container class="mt-5">
      <v-row>
        <v-col cols="12" lg="6" md="6" sm="7" xs="12">
          <text-section heading="licence number" type="licence"></text-section>
          <search-text-box
            :action="verify"
            :vModel="searchText"
            type="licence number"
            :valueType="valueType"
          ></search-text-box>
          <v-alert dense outlined type="error" v-show="showAlert">{{
            errorMsg
          }}</v-alert>
        </v-col>
        <v-col cols="12" md="5" lg="5" sm="5" offset-lg="1" offset-md="1">
          <div class="text-center">
            <v-overlay :value="overlay">
              <v-progress-circular
                indeterminate
                size="64"
              ></v-progress-circular>
            </v-overlay>
          </div>
          <div v-show="validated && !snackbar.state" id="parent-element">
            <v-icon color="green" size="100" id="check-box">mdi-check</v-icon>
            <v-img
              id="account-icon"
              :src="require('../assets/board_logo.png')"
              width="100"
              height="50"
              contain
            ></v-img>

            <v-card dark class="mx-auto" id="black-card" max-width="400">
              <v-list-item two-line>
                <v-list-item-content>
                  <v-list-item-title class="title text-center mt-10 pl-3 ">
                    <span
                      class="d-inline-block text-left"
                      style=" display: flex; text-wrap: wrap;  "
                      >{{ receipt.customer }}</span
                    >
                  </v-list-item-title>
                  <v-list-item-subtitle class="text-left mt-8 pl-3 title ">
                    Gaming Operational licence
                  </v-list-item-subtitle>
                  <v-list-item-subtitle class="text-left mt-8 pl-3  "
                    >Expiration date:
                    {{
                      getExpirationDate(receipt.payment_ref)
                    }}</v-list-item-subtitle
                  >
                </v-list-item-content>
              </v-list-item>
              <v-divider></v-divider>

              <!-- <v-card-text>
                <v-row align="center">
                  <v-col class="display-2 text-center" cols="12">{{
                    receipt.amount
                  }}</v-col>
                </v-row>
              </v-card-text> -->
              <v-divider></v-divider>

              <v-list-item>
                <v-list-item-subtitle class="my-6 pl-3"
                  >licence number :
                  {{ receipt.receipt_no }}</v-list-item-subtitle
                >
              </v-list-item>

              <v-divider></v-divider>
            </v-card>
          </div>
          <side-image :isValidating="!validated"></side-image>
        </v-col>
      </v-row>
      <v-snackbar v-model="snackbar.state">
        {{ snackbar.msg }}

        <template v-slot:action="{ attrs }">
          <v-btn
            color="red"
            text
            v-bind="attrs"
            @click="() => (snackbar.state = false)"
          >
            Close
          </v-btn>
        </template>
      </v-snackbar>
    </v-container>
  </div>
</template>
<script>
import axios from "axios";
import SideImage from "../components/side-image";
import TextSection from "../components/text-section";
import SearchTextBox from "../components/search-textbox";
export default {
  components: {
    SideImage,
    TextSection,
    SearchTextBox,
  },
  data() {
    return {
      showAlert: false,
      isValidating: true,
      errorMsg: "",
      searchText: "",
      overlay: false,
      receipt: {},
      valueType: "text",
      snackbar: {
        state: false,
        msg: "",
      },
    };
  },
  computed: {},
  methods: {
    getExpirationDate(ref) {
      if (`${ref}`.includes("-")) {
        return "31-12-" + `${ref}`.split("|")[3].split("-")[2];
      } else return "31-12-2023";
    },
    showError(msg) {
      this.errorMsg = msg;
      this.overlay = false;
      this.showAlert = true;
      this.isValidating = true;
      setTimeout(() => {
        const l = this.loader;
        this[l] = !this[l];

        this.showAlert = false;
      }, 2000);
    },
    verify(licenceNumber) {
      this.isValidating = true;
      const api = "https://receipts.mekiotechdigital.com/api/receipts";
      let data = licenceNumber.trim();
      if (licenceNumber) {
        this.overlay = true;
        let vm = this;
        // if (typeof data != "number") {
        //   this.showError(
        //     "Invalid Number Format. Note: Alphabets are not accepted"
        //   );
        //   return;
        // }
        axios({
          url: `${api}/verify/${data}`,
          data: data,
          method: "GET",
        })
          .then(function(res) {
            if (res && res.data.code == 0) {
              setTimeout(() => {
                vm.isValidating = true;
                vm.showError(res.data.message);
              }, 1000);
            } else if (res && res.data.code == 1) {
              if (res.data.content.length > 1) {
                vm.snackbar.state = true;
                vm.snackbar.msg =
                  "More than one record found, Please check the receipt number and try again...";
              } else {
                vm.receipt = res.data.content;
                vm.validated = true;
              }
              vm.isValidating = false;
              vm.overlay = false;
            }
          })
          .catch(function() {});
      } else {
        this.showError("Please enter your a valid Receipt Number.");
      }
    },
  },
  created() {
    if (this.$route.params.id) {
      const id = this.$route.params.id;
      this.searchText = id;
      this.verify(id);
    }
  },
};
</script>
<style>
#parent-element {
  position: relative;
}
#check-box {
  position: absolute;
  z-index: 5;
  right: 1%;
  top: -40px;
}
#account-icon {
  position: absolute;
  left: 6%;
  z-index: 5;
  top: -25px;
  color: #a8b8f1 !important;
}
#black-card {
  position: relative;
  z-index: 1;
  background: #3c3168 !important;
}
h1 {
  color: #383838;
  font-size: 30px;
  font-weight: 700;
  line-height: 1.2;
}
.v-input__icon .v-input__icon--append-outer .v-icon--link {
  font-size: 44px;
}
div.v-input__icon.v-input__icon--append-outer button.v-icon {
  color: black !important;
  background: #f2f8fe !important;
  padding: 16px 18px;
  border-radius: 0px 30px 30px 0px !important;
  margin-top: -6px;
}
div.v-input__slot {
  border: 3px solid #f2f8fe !important;
  border-radius: 30px 0 0 30px !important;
}
div.input__control {
  border: 3px soild green !important;
}
</style>
